<template>
    <div>
        <JsonLd :json="jsonld" />
        <main id="special220901">
            <!-- 特集Specialコンテンツここから -->

            <!-- KV Section ここから -->
            <section id="kv" class="kv">
                <video playsinline autoplay muted loop>
                    <source src="../../../assets/luxury_travel/luxury_travel04/video/bg_main.mp4" type="video/mp4" />
                </video>
                <div id="kv__black"></div>
                <!-- kv__black -->
            </section>
            <!-- kv -->

            <div class="kv__titleArea">
                <p class="kv__title--sub fadeIn">Luxury Travel</p>
                <h2 class="kv__title fadeIn" id="kv__title">
                    Dewa: Monks,<br />
                    Merchants,<br />
                    and Mountain Ascetics
                </h2>
                <p class="playVideo fadeIn" @click="openStreaksPlayer('luxurytravel/luxurytravel04/luxury01')">
                    <img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel04/svg/play_icon.svg" alt="">Play video
                </p>
            </div>
            <!-- kv__titleArea -->

            <!-- Lead Section ここから -->
            <section id="lead" class="lead">
                <div class="lead__largeImage">
                    <img src="../../../assets/luxury_travel/luxury_travel04/large_dammy.png" alt="" />
                </div>
                <!-- lead__largeImage -->

                <div class="leadSection01">
                    <div class="lead__des_wrapper">
                        <p class="lead__des fadeIn">
                            The Yamagata region blends stunning mountain scenery with a rich religious
                            heritage. One of the most striking examples of this harmony can be seen at
                            Yamadera Temple, founded by the monk Ennin in 860 CE.
                        </p>
                    </div>
                    <!-- lead__des_wrapper -->
                </div>
                <!-- leadSection01 -->

                <div class="leadSecion02">
                    <div class="leadPhotosArea1">
                        <img class="lead__photos01 fadeIn" src="../../../assets/luxury_travel/luxury_travel04/photos01.jpg" alt="" />
                        <img class="lead__photos02 fadeIn" src="../../../assets/luxury_travel/luxury_travel04/photos02.jpg" alt="" />
                    </div>
                    <!-- leadPhotosArea1 -->

                    <div class="lead__des_wrapper2">
                        <p class="lead__des2 fadeIn">
                            Ennin is also linked to the introduction of safflower cultivation in Yamagata,
                            beginning a lucrative trade in the plant’s dye that brought prosperity to the region.
                            Explore the legacy of this wealth in the coastal city of Sakata.
                        </p>
                    </div>
                    <!-- lead__des_wrapper2 -->
                </div>
                <!-- leadSecion02 -->

                <div class="leadSection03">
                    <div class="leadPhotosArea2">
                        <img class="lead__photos03 fadeIn" src="../../../assets/luxury_travel/luxury_travel04/photos03.jpg" alt="" />
                    </div>
                    <!-- leadPhotosArea2 -->

                    <div class="lead__des_wrapper3">
                        <p class="lead__des3 fadeIn">
                            Discover the Shugendo faith of the Dewa Sanzan mountains with a
                            <i>yamabushi</i> ascetic as your guide. Trace a journey of rebirth from Mt. Haguro,
                            which represents life, through the afterlife on Mt. Gassan and rebirth on Mt. Yudono.
                        </p>
                    </div>
                    <!-- lead__des_wrapper3 -->
                </div>
                <!-- leadSection03 -->
            </section>
            <!-- lead -->

            <!-- Heritage Section ここから -->
            <section class="heritage" id="heritage">
                <div class="heritage__largeImage">
                    <video playsinline autoplay muted loop>
                        <source src="../../../assets/luxury_travel/luxury_travel04/video/bg_heritage.mp4" type="video/mp4" />
                    </video>
                    <div id="heritage__largeImage__black"></div>
                    <!-- heritage__largeImage__black -->
                </div>
                <!-- heritage__largeImage -->

                <div class="heritage_titleArea">
                    <h1 class="heritage_title fadeIn" id="heritage_title">
                        Dewa Sanzan<br />
                        – the Three Holy Mountains <br />of Yamagata
                    </h1>
                    <p class="playVideo fadeIn" @click="openStreaksPlayer('luxurytravel/luxurytravel04/luxury02')">
                        <img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel04/svg/play_icon.svg" alt="">Play video
                    </p>
                </div>
                <!-- heritage_titleArea -->
            </section>
            <!-- heritage -->

            <section class="heritage_horizon">
                <div class="heritage_horizon_inner">
                    <div class="japanHeritageWrapper">
                        <img src="../../../assets/luxury_travel/luxury_travel04/svg/japan_heritage.svg" class="japanHeritage" />
                    </div>
                    <!-- japanHeritageWrapper -->

                    <div class="photo_wrapper heritage__photos01">
                        <img src="../../../assets/luxury_travel/luxury_travel04/photos04.jpg" alt="" class="heritage__photos01_inner" />
                    </div>
                    <!-- heritage__photos01 -->

                    <p class="heritage__des">
                        Mt. Haguro, Mt. Gassan, and Mt. Yudono – these are the Dewa Sanzan,
                        the three sacred mountains that are central to the faith of the
                        <i>yamabushi</i> ascetics of northern Japan. The mountains are dotted
                        with shrines and lodging houses for pilgrims, allowing you to
                        experience a truly authentic stay.
                    </p>

                    <div class="photo_wrapper heritage__photos02">
                        <img src="../../../assets/luxury_travel/luxury_travel04/photos05.jpg" alt="" class="heritage__photos02_inner" />
                    </div>
                    <!-- heritage__photos02 -->

                    <p class="heritage__des1_2">
                        Explore the mercantile heritage of Sakata, a major stop on the
                        maritime trade route between Osaka and Japan’s north. The merchants
                        who came here brought a demand for fine culture,
                        reflected in the opulence of the Somaro Maiko Tea House.
                    </p>

                    <div class="photo_wrapper heritage__photos03">
                        <img class="heritage__photos03_inner" src="../../../assets/luxury_travel/luxury_travel04/photos06.jpg" alt="" />
                    </div>
                    <!-- heritage__photos03 -->

                    <p class="heritage__des2">
                        The mountainous interior of Yamagata has attracted religious believers
                        throughout the centuries. Famously visited by the haiku poet Matsuo
                        Basho, the Buddhist temple of Yamadera sprawls up a forested
                        mountainside, with spectacular views over the valley below from
                        Godaido hall near the apex of the temple.
                    </p>

                    <div class="photo_wrapper heritage__photos04">
                        <img class="heritage__photos04_inner" src="../../../assets/luxury_travel/luxury_travel04/photos07.jpg" alt="" />
                    </div>
                    <!-- heritage__photos04 -->

                    <div class="photo_wrapper heritage__photos05">
                        <img class="heritage__photos05_inner" src="../../../assets/luxury_travel/luxury_travel04/photos08.jpg" alt="" />
                    </div>
                    <!-- heritage__photos04 -->

                    <p class="heritage__des3">
                        After descending from Yamadera, refresh yourself with a tasty <i>Chikara konnyaku</i>
                        (a snack made of soft, chewy konjac simmered in soy sauce),
                        seasoned with an invigorating dollop of <i>karashi</i> mustard.
                    </p>

                    <div class="heritage__photos06">
                        <img class="heritage__photos06_inner" src="../../../assets/luxury_travel/luxury_travel04/photos09.jpg" alt="" />
                    </div>
                    <!-- heritage__photos06 -->
                </div>
                <!-- heritage_horizon_inner -->
            </section>
            <!-- heritage_horizon -->

            <!-- Accommodation Section ここから -->
            <section class="accommodation" id="accommodation">
                <div class="accommodation__largeImage">
                    <video playsinline autoplay muted loop>
                        <source src="../../../assets/luxury_travel/luxury_travel04/video/bg_accommodation.mp4" type="video/mp4" />
                    </video>
                    <div id="accommodation__largeImage__black"></div>
                    <!-- accommodation__largeImage__black -->
                </div>
                <!-- accommodation__largeImage -->

                <div class="accommodation__title_wrapper">
                    <h2 class="accommodation__title fadeIn">
                        A Modern Master Presents<br/>Traditional Hospitality
                    </h2>
                    <p class="playVideo fadeIn" @click="openStreaksPlayer('luxurytravel/luxurytravel04/luxury03')">
                        <img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel04/svg/play_icon.svg" alt="">Play video
                    </p>
                </div>
                <!-- accommodation__title_wrapper -->

                <img
                    class="accommodation_tag fadeIn"
                    src="../../../assets/luxury_travel/luxury_travel04/svg/accommodation.svg"
                    alt="Accommodation"
                />

                <div class="accomodation_section01">
                    <div class="accommodation_photo01 fadeIn">
                        <img
                            class="accommodation__photos01_inner"
                            src="../../../assets/luxury_travel/luxury_travel04/photos10.jpg"
                            alt=""
                        />
                    </div>
                    <!-- accommodation_photo01 -->

                    <div class="accommodation__des_wrapper">
                        <p class="accommodation__des fadeIn">
                            The hot springs of Ginzan Onsen are best seen by night
                            when the <i>ryokan</i> inns are illuminated by gas lighting,
                            transporting you back to Japan’s Taisho period (1912-1926).
                            At the Fujiya inn, this traditional atmosphere is balanced with modern luxury,
                            ensuring a truly memorable stay.
                        </p>
                    </div>
                    <!-- accommodation__des_wrapper -->
                </div>
                <!-- accomodation_section01 -->

                <div class="accomodation_section02">
                    <div class="accommodation_photo02 fadeIn">
                        <img
                            class="accommodation__photos02_inner"
                            src="../../../assets/luxury_travel/luxury_travel04/photos11.jpg"
                            alt=""
                        />
                        <img
                            class="accommodation__photos03_inner"
                            src="../../../assets/luxury_travel/luxury_travel04/photos12.jpg"
                            alt=""
                        />
                    </div>
                    <!-- accommodation_photo02 -->

                    <div class="accommodation_des02_wrapper">
                        <p class="accommodation_des02 fadeIn">
                            This 100-year-old property has been renovated by famed Japanese architect Kengo Kuma,
                            incorporating traditional design elements.
                        </p>
                    </div>
                    <!-- accommodation__des02_wrapper -->
                </div>
                <!-- accomodation_section02 -->

                <div class="accommodation_largeImageArea fadeIn">
                    <img class="accommodation__largePhoto" src="../../../assets/luxury_travel/luxury_travel04/large02.jpg" alt="" />
                    <div class="accommodation_des03_wrapper">
                        <p class="accommodation_des03 fadeIn">
                            The atrium is enclosed in a bamboo latticework comprised of 1.2 million separate pieces,
                            and the exterior wall is made of hand-blown stained glass.
                            The minimalist rooms continue the natural theme with <i>Echizen-washi</i> paper covering the walls.
                        </p>
                    </div>
                    <!-- accommodation_des03_wrapper -->
                </div>
                <!-- accommodation_largeImageArea -->

                <div class="accomodation_section03">
                    <div class="accommodation_photo03 fadeIn">
                        <img src="../../../assets/luxury_travel/luxury_travel04/photos13.jpg" alt="" />
                    </div>
                    <!-- accommodation_photo03 -->

                    <div class="accommodation_des04_wrapper">
                        <p class="accommodation_des04 fadeIn">
                            After a soak in the <i>onsen</i> hot springs, you can relax at the Café and Bar Courrier,
                            decorated in a Taisho period style.
                            The second-floor seating provides a splendid view of the main street,
                            the hot spring river and the magnificent wooden frontages of the inns.
                            Don’t miss trying the locally-produced whiskey!
                        </p>
                    </div>
                    <!-- accommodation__des03_wrapper -->
                </div>
                <!-- accomodation_section04 -->
            </section>
            <!-- accommodation -->

            <!-- Cuisine Section    ここから -->
            <section id="cuisine" class="cuisine">
                <div class="cuisine__largeImage">
                    <video playsinline autoplay muted loop>
                        <source src="../../../assets/luxury_travel/luxury_travel04/video/bg_cuisine.mp4" type="video/mp4" />
                    </video>
                    <div id="cuisine__largeImage__black"></div>
                    <!-- cuisine__largeImage__black -->
                </div>
                <!-- cuisine__largeImage -->

                <img class="cuisine_tag fadeIn" src="../../../assets/luxury_travel/luxury_travel04/svg/cuisine.svg" alt="Cuisine" />

                <div class="cuisine__title_wrapper">
                    <h2 class="cuisine__title fadeIn">
                        Nature’s Bounty:<br />the Wild Plants<br />of the Dewa Sanzan
                    </h2>
                    <p class="playVideo fadeIn" @click="openStreaksPlayer('luxurytravel/luxurytravel04/luxury04')">
                        <img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel04/svg/play_icon.svg" alt="">Play video
                    </p>
                </div>
                <!-- cuisine__title_wrapper -->

                <div class="cuisine_section01">
                    <div class="cuisine__des_wrapper">
                        <p class="cuisine__des fadeIn">
                            The food culture of the Yamagata region has received global recognition,
                            with the city of Tsuruoka designated as a UNESCO Creative City of Gastronomy.
                            Much of the region’s cuisine draws on the rich religious heritage of
                            the Dewa Sanzan mountains for both recipes and ingredients.
                        </p>
                    </div>
                    <!-- cuisine__des_wrapper -->
                </div>
                <!-- cuisine_section01 -->

                <div class="cuisine_section02">
                    <div class="cuisine_photo01 fadeIn">
                        <img src="../../../assets/luxury_travel/luxury_travel04/photos14.jpg" alt="" />
                        <img src="../../../assets/luxury_travel/luxury_travel04/photos15.jpg" alt="" />
                    </div>
                    <!-- cuisine_photo01 -->

                    <div class="cuisine__des02_wrapper">
                        <p class="cuisine__des02 fadeIn">
                            Dewaya has catered to the pilgrim trade for nearly a hundred years,
                            and uses <i>sansai</i> wild vegetables and flowers such as safflower and
                            ostrich fern gathered from the slopes of Mt. Gassan. While drawing on traditional recipes,
                            the chef at Dewaya also mixes in elements of modern Western cooking to create a flavorsome fusion <i>sansai</i> cuisine.
                        </p>
                    </div>
                    <!-- cuisine__des02_wrapper -->
                </div>
                <!-- cuisine_section02 -->

                <div class="cuisine_section03">
                    <div class="cuisine_photo02 fadeIn">
                        <img src="../../../assets/luxury_travel/luxury_travel04/photos16.jpg" alt="" />
                        <img src="../../../assets/luxury_travel/luxury_travel04/photos17.jpg" alt="" />
                    </div>
                    <!-- cuisine_photo02 -->

                    <div class="cuisine__des03_wrapper">
                        <p class="cuisine__des03 fadeIn">
                            <i>Yamabushi</i> ascetics have also contributed to this culinary legacy.
                            Their vegetable-based <i>sansai</i> dishes are designed to cleanse body and
                            soul through the absorption of the natural bounty of the Dewa Sanzan mountains.
                            You can try this delicious fare for yourself at the Saikan pilgrim lodge near the top of Mt. Haguro,
                            including the lodge’s signature <i>goma dofu</i> recipe.
                        </p>
                    </div>
                    <!-- cuisine__des03_wrapper -->
                </div>
                <!-- cuisine_section03 -->
            </section>
            <!-- cuisine -->

            <!-- Experience Section ここから -->
            <section id="experience" class="experience">
                <div class="experience__largeImage">
                    <video playsinline autoplay muted loop>
                        <source src="../../../assets/luxury_travel/luxury_travel04/video/bg_experience.mp4" type="video/mp4" />
                    </video>
                    <div id="experience__largeImage__black"></div>
                    <!-- experience__largeImage__black -->
                </div>
                <!-- experience__largeImage -->

                <div class="experience__title_wrapper">
                    <h2 class="experience__title fadeIn">
                        In the Footsteps<br/>of Ascetics<br/>and Merchants
                    </h2>
                    <p class="playVideo fadeIn" @click="openStreaksPlayer('luxurytravel/luxurytravel04/luxury05')">
                        <img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel04/svg/play_icon.svg" alt="">Play video
                    </p>
                </div>
                <!-- experience__title_wrapper -->

                <!-- Experience Horizon ここから -->
                <section class="experience_horizon">
                    <div class="experience_horizon_inner">
                        <div class="experienceTagWrapper">
                            <img src="../../../assets/luxury_travel/luxury_travel04/svg/experience.svg" class="experience_tag" />
                        </div>
                        <!-- experienceTagWrapper -->

                        <div class="photo_wrapper experience__photos01">
                            <img
                                src="../../../assets/luxury_travel/luxury_travel04/photos18.jpg"
                                alt=""
                                class="experience__photos01_inner"
                            />
                        </div>
                        <!-- experience__photos01 -->

                        <p class="experience__des1">
                            The mountain paths of the Dewa Sanzan offer not only great hiking
                            opportunities, but a chance to see the beautiful natural landscapes
                            and deep spiritual underpinnings of the region.
                        </p>

                        <div class="photo_wrapper experience__photos02">
                            <img
                                src="../../../assets/luxury_travel/luxury_travel04/photos19.jpg"
                                alt=""
                                class="experience__photos02_inner"
                            />
                        </div>
                        <!-- experience__photos02 -->

                        <p class="experience__des2">
                            Mt. Haguro, the smallest of the Dewa Sanzan, provides the easiest challenge of the three peaks.
                            From the pilgrim lodgings below the mountain,
                            a flight of 2,446 stone steps winds upward amid majestic cedar trees.
                            With a <i>yamabushi</i> ascetic as your guide, you’ll pass ancient shrines and
                            the lofty five-story pagoda of Mt. Haguro, before arriving at the shrine complex on the peak,
                            dedicated to the gods of all three of the Dewa Sanzan mountains.
                        </p>

                        <div class="photo_wrapper experience__photos03">
                            <img
                                src="../../../assets/luxury_travel/luxury_travel04/photos20.jpg"
                                alt=""
                                class="experience__photos03_inner"
                            />
                        </div>
                        <!-- experience__photos03 -->

                        <p class="experience__des3">
                            The culture of Sakata’s <i>maiko</i> apprentice geisha is a legacy of the city’s prosperity as a trading port.
                            The <i>maiko</i> serve tea in the richly-appointed surroundings of the Somaro Maiko Tea House and
                            entertain guests with traditional dance.
                        </p>

                        <div class="photo_wrapper experience__photos04">
                            <img
                                src="../../../assets/luxury_travel/luxury_travel04/photos21.jpg"
                                alt=""
                                class="experience__photos04_inner"
                            />
                        </div>
                        <!-- experience__photos04 -->

                        <div class="photo_wrapper experience__photos05">
                            <img
                                src="../../../assets/luxury_travel/luxury_travel04/photos22.jpg"
                                alt=""
                                class="experience__photos05_inner"
                            />
                        </div>
                        <!-- experience__photos05 -->

                        <p class="experience__des4">
                            Watch their graceful, elegant performances, accompanied by chanting and shamisen music,
                            while enjoying local sake and other delicacies.
                        </p>
                    </div>
                    <!-- experience_horizon_inner -->
                </section>
                <!-- experience_horizon -->
            </section>
            <!-- experience -->

            <div class="maplinkArea">
                <a
                    class="maplink"
                    href="https://www.google.com/maps/d/edit?hl=ja&hl=ja&mid=1yAuMi8Ma5p9mYuBNmR6Vm8-YqUYY6uo&ll=38.302337564527704%2C140.3851406628296&z=15"

                    target="_blank"
                    >See on map <img src="../../../assets/luxury_travel/luxury_travel04/svg/outerlink.svg"
                /></a>
            </div>
            <!-- maplinkArea -->

            <Questionnaire :page-id="pageId" />

            <!-- See other luxury destinations ここから -->
            <SeeOtherLuxury />
            <!-- See other luxury destinations ここまで -->

            <!-- Nearby Japan Heritage Sites 挿入箇所 -->

            <!-- Other Sites in Same Category 挿入箇所 -->

            <!-- 特集Specialコンテンツここまで-->
            <streaks-player ref="streaks"></streaks-player>
        </main>
    </div>
</template>

<script>
import StreaksPlayer from "@/components/StreaksPlayer/StreaksPlayer";
import ApiRouter from "@/components/Systems/ApiRouter";
import SeeOtherLuxury from "../SeeOtherLuxury";
import "video.js/dist/video-js.css";
import Questionnaire from "../Questionnaire.vue";
import JsonLd from "@/components/JsonLd/JsonLd.vue";

export default {
    name: "LuxuryTravel04",
    components: {JsonLd, Questionnaire, StreaksPlayer, SeeOtherLuxury },
    mixins: [ApiRouter],
    data: function () {
        return {
            publicPath: `${process.env.VUE_APP_PUBLIC_PATH}`,
            pageId: '4',
            jsonld: {
                "@context": "https://schema.org",
                "@type": "Article",
                "mainEntityOfPage": window.location.href,
                "headline": "Dewa: monks, merchants, and mountain ascetics",
                "description": "Japan Heritage ties together historical sites, shrines, temples, traditional arts, castles, armor," +
                    "and other cultural assets. Find photos, videos, tourist information, and more.",
                "image": [
                    require('../../../assets/luxury_travel/index/luxury04.jpg')
                ],
                "datePublished": "2022/09/07",
                "dateModified": "2023/12/19",
                "author": [{
                    "@type": "Organization",
                    "name": "Japan National Tourism Organization",
                    "url": "https://www.japan.travel/japan-heritage/"
                }]
            }
        };
    },
    mounted: function () {
        document.title = 'Japan Heritage Official Site | Stories and travel information | JNTO'
        let url = this.publicPath + "js/luxurytravel/luxurytravel04.js";
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", url);
        document.head.appendChild(recaptchaScript);
    },
    methods: {
        openStreaksPlayer: function (id) {
            this.$refs.streaks.open(id);
        },
    },
};
</script>

<style src="./LuxuryTravel04.scss" lang="scss" scoped/>
